module.exports = __webpack_public_path__ + "static/media/BSHARE.af05c131.png";